import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation, Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import ADD_TO_SHOPPING_LIST from '../operations/mutations/add-to-shopping-list.js';
import { wishlistCountVar } from '../utils/wishlist-count-var.js';

const useAddToShoppingList = ({ setLocalShoppingList , isLoggedIn , localShoppingListId , onError , onCompleted  })=>{
    const { locale  } = useIntl();
    const [hasError, setHasError] = React.useState(false);
    const [mutation, { data: data1 , loading , error  }] = useMutation(ADD_TO_SHOPPING_LIST, {
        onError () {
            onError === null || onError === void 0 ? void 0 : onError();
        },
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        refetchQueries: [
            'GetShoppingListCount',
            'GetMyWishlistId',
            'GetMyWishlist'
        ]
    });
    const handleOnCompleted = React.useCallback((data)=>{
        if (data.addToShoppinglist.__typename === 'AddToShoppinglistFailureResponse') {
            onError === null || onError === void 0 ? void 0 : onError();
        } else {
            if ((data === null || data === void 0 ? void 0 : data.addToShoppinglist.__typename) === 'AddToShoppinglistSuccessResponse') {
                // If the user is not logged in and does not have a locally stored id yet, we need to store it.
                if (!isLoggedIn && !localShoppingListId) {
                    setLocalShoppingList({
                        id: data.addToShoppinglist.result.id
                    });
                }
                var _length;
                /*
            Update the wishlist count to reflect the new amount of items in the wishlist.
            Otherwise the wishlist count will only be updated after a page refresh. This var is shared
            between wish list components and the wish list icon in the header to display the correct
            amount of items in the wishlist and keep the value synchronized after adding and removing items.
          */ wishlistCountVar((_length = data.addToShoppinglist.result.items.length) !== null && _length !== void 0 ? _length : null);
            }
        }
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(data);
    }, [
        onCompleted,
        onError,
        isLoggedIn,
        localShoppingListId,
        setLocalShoppingList
    ]);
    const addToShoppinglist = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(productSkus, shoppinglistId) {
            try {
                const { data  } = yield mutation({
                    variables: {
                        input: {
                            productSkus,
                            shoppinglistId: shoppinglistId !== null && shoppinglistId !== void 0 ? shoppinglistId : null,
                            shoppinglistType: Types.ShoppinglistType.WISHLIST
                        }
                    }
                });
                if (data) {
                    handleOnCompleted(data);
                }
            } catch (e) {
                setHasError(true);
                console.error('Error while adding a wishlist item to the shopping list', e);
            }
        });
        return function(productSkus, shoppinglistId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleOnCompleted,
        mutation
    ]);
    var ref, ref1;
    return {
        addToShoppinglist,
        loading,
        error: (ref1 = (ref = error !== null && error !== void 0 ? error : hasError) !== null && ref !== void 0 ? ref : (data1 === null || data1 === void 0 ? void 0 : data1.addToShoppinglist.__typename) === 'AddToShoppinglistFailureResponse') !== null && ref1 !== void 0 ? ref1 : null
    };
};

export { useAddToShoppingList };
//# sourceMappingURL=use-add-to-shopping-list.js.map
